import React from 'react';
import AppLayout from 'containers/layouts/AppLayout';
import AppContainer from 'containers/layouts/AppContainer';
import { Grid, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  gridContainer: {
    marginTop: theme.spacing(5),
    textAlign: 'center',
  },
}));

interface AddActorPageLayoutProps {
  children?: React.ReactNode;
}

const AddActorPageLayout = ({ children }: AddActorPageLayoutProps) => {
  const { classes: styles } = useStyles();

  return (
    <AppLayout>
      <AppContainer>
        <Box className={styles.gridContainer}>
          <Grid container spacing={10}>
            <Grid item lg={12}>
              {children}
            </Grid>
          </Grid>
        </Box>
      </AppContainer>
    </AppLayout>
  );
};

export default AddActorPageLayout;
